import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import PatientReservationPackages from './PatientReservationPackages';
import PatientAppointments from './PatientAppointments';
import PatientTransactions from './PatientTransactions';
import PatientJourneys from './PatientJourneys';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import { Appointments, ReservationPackage } from 'constants/resources';
import '../../style.css';
var sameSummary = function (prev, next) { return (prev === null || prev === void 0 ? void 0 : prev.active) === next.active && (prev === null || prev === void 0 ? void 0 : prev.total) === next.total; };
var TabLabel = function (_a) {
    var label = _a.label, badge = _a.badge;
    return (_jsxs("span", { className: "patient-profile__tab-label", children: [_jsx("span", { children: label }), badge ? _jsx("span", { className: "patient-profile__tab-badge", children: badge }) : null] }));
};
var PatientTabs = function (props) {
    var _a, _b, _c;
    var t = props.translate, patient = props.patient;
    var permissionService = services.permissionService, medicalCenterService = services.medicalCenterService;
    var medicalCenter = medicalCenterService.useMedicalCenterInfo().data;
    var journeysEnabled = ((_a = medicalCenter === null || medicalCenter === void 0 ? void 0 : medicalCenter.getConfig()) === null || _a === void 0 ? void 0 : _a.isPatientJourneysEnabled()) === true;
    var canSeeJourneys = permissionService.hasPatientJourneysFeatureEnabled(journeysEnabled);
    var _d = useState(null), packageSummary = _d[0], setPackageSummary = _d[1];
    var _e = useState(null), visitSummary = _e[0], setVisitSummary = _e[1];
    var _f = useState(null), journeySummary = _f[0], setJourneySummary = _f[1];
    var reportPackages = useCallback(function (summary) {
        setPackageSummary(function (prev) { return (sameSummary(prev, summary) ? prev : summary); });
    }, []);
    var reportVisits = useCallback(function (summary) {
        setVisitSummary(function (prev) { return (sameSummary(prev, summary) ? prev : summary); });
    }, []);
    var reportJourneys = useCallback(function (summary) {
        setJourneySummary(function (prev) { return (sameSummary(prev, summary) ? prev : summary); });
    }, []);
    var balance = patient.getAvailableBalance();
    var balanceBadge = Number.isFinite(balance)
        ? t('common:price', { amount: balance })
        : undefined;
    var items = [];
    if (permissionService.hasPermissionToIndex(ReservationPackage)) {
        items.push({
            key: 'packages',
            label: (_jsx(TabLabel, { label: t('tab.patientPackages'), badge: packageSummary
                    ? t('tab.activeCount', { count: packageSummary.active })
                    : undefined })),
            children: (_jsx(PatientReservationPackages, { patient: patient, onSummary: reportPackages, onAdd: props.onAddPackage }))
        });
    }
    items.push({
        key: 'financials',
        label: (_jsx(TabLabel, { label: t('tab.patientFinancials'), badge: balanceBadge })),
        children: (_jsx(PatientTransactions, { patient: patient, onSettleDue: props.onSettleDue }))
    });
    if (permissionService.hasPermissionToIndex(Appointments)) {
        items.push({
            key: 'visits',
            label: (_jsx(TabLabel, { label: t('tab.patientVisits'), badge: visitSummary
                    ? t('tab.totalCount', { count: visitSummary.total })
                    : undefined })),
            children: (_jsx(PatientAppointments, { patient: patient, onSummary: reportVisits, onAdd: props.onScheduleVisit }))
        });
    }
    if (canSeeJourneys) {
        items.push({
            key: 'journeys',
            label: (_jsx(TabLabel, { label: t('tab.patientJourneys'), badge: journeySummary
                    ? t('tab.activeCount', { count: journeySummary.active })
                    : undefined })),
            children: (_jsx(PatientJourneys, { patient: patient, onSummary: reportJourneys }))
        });
    }
    var defaultKey = ((_b = items.find(function (item) { return item.key === 'visits'; })) === null || _b === void 0 ? void 0 : _b.key) || ((_c = items[0]) === null || _c === void 0 ? void 0 : _c.key) || '';
    var _g = useState(defaultKey), activeKey = _g[0], setActiveKey = _g[1];
    var currentKey = items.some(function (item) { return item.key === activeKey; })
        ? activeKey
        : defaultKey;
    return (_jsxs("div", { id: "patient-tabs", className: "patient-profile__tabs", "data-onboarding": "patient-tabs", children: [_jsx("div", { className: "patient-profile__tabbar no-print", role: "tablist", children: items.map(function (item) {
                    var selected = item.key === currentKey;
                    return (_jsx("button", { type: "button", role: "tab", "aria-selected": selected, className: selected ? 'is-active' : undefined, "data-onboarding": item.key === 'visits' ? 'patient-appointments-tab' : undefined, onClick: function () { return setActiveKey(item.key); }, children: item.label }, item.key));
                }) }), items.map(function (item) { return (_jsx("div", { role: "tabpanel", hidden: item.key !== currentKey, className: "patient-profile__tab-panel", children: item.children }, item.key)); })] }));
};
export default localeTranslator(PatientTabs, 'showPatient');
